<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar logo="/img/logo.svg" v-bind:autoClose="false">
      <template slot-scope="props" slot="links">
        <sidebar-item
          v-if="permisos['ver dashboard'] && !isAlmacenero"
          :link="{
            name: 'Dashboard',
            icon: 'ni ni-chart-bar-32 text-primary',
            path: '/dashboard'
          }"
        ></sidebar-item>
        <operations-manual-link />
        <daily-menu-section />
        <on-demand-section />
        <sidebar-item
          v-if="!isAlmacenero"
          :link="{
            name: 'Pedidos Tienda',
            icon: 'ni ni-building text-success',
          }"
        >
          <sidebar-item
            :link="{ name: 'Pedidos Tienda', path: '/pedidos-tienda' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Control de Stock', path: '/pedidos-tienda/control-stock' }"
          ></sidebar-item>
        </sidebar-item>
        <franchise-section />
        <sidebar-item
          v-if="!isAlmacenero"
          :link="{
            name: 'Insumos',
            icon: 'ni ni-basket text-primary'
          }"
        >
          <sidebar-item
            :link="{
              name: 'Lista de Insumos Daily',
              path: '/insumos'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Lista de Insumos Foodcourt',
              path: '/insumos/foodcourt'
            }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="permisos['ver consolidados'] && !isAlmacenero"
          :link="{
            name: 'Consolidados',
            icon: 'ni ni-chart-pie-35 text-primary',
            path: '/consolidados'
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="!isAlmacenero"
          :link="{
            name: 'Precantidades',
            icon: 'ni ni-shop text-primary'
          }"
        >
          <sidebar-item
            :link="{
              name: 'Lista de Precantidades Daily',
              path: '/precantidades'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Lista de Precantidades Foodcourt',
              path: '/precantidades/foodcourt'
            }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="!isAlmacenero"
          :link="{
            name: 'Auditorías',
            icon: 'ni ni-check-bold text-primary'
          }"
        >
          <sidebar-item
            :link="{
              name: 'Historial',
              path: '/auditorias'
            }"
          ></sidebar-item>
          <sidebar-item
            :link="{
              name: 'Intervenciones',
              path: '/auditorias/intervenciones'
            }"
          ></sidebar-item>
        </sidebar-item>
        <sidebar-item
          v-if="permisos['ver facturas'] && !isAlmacenero"
          :link="{
            name: 'Facturas',
            icon: 'ni ni-single-copy-04 text-primary',
            path: '/facturas'
          }"
        ></sidebar-item>
        <sidebar-item
          v-if="!isAlmacenero && showKitchenCharges"
          :link="{
            name: 'Cobros de insumos',
            icon: 'ni ni-money-coins text-primary',
            path: '/cobros-insumos'
          }"
        ></sidebar-item>
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar @open-portal-update="openPortalUpdate"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
    <support-fab @click="onSupportClick" @ver-tickets="onVerTicketsClick" />
    <support-ticket-modal :show.sync="showTicketModal" />
    <mis-tickets-modal
      :show.sync="showMisTicketsModal"
      :focus-ticket-id="focusTicketId"
      :initial-action="ticketAction"
    />
    <portal-update-modal :items="portalUpdateQueue" @close="closePortalUpdates" />
    <manual-acknowledgement-notice v-if="hasDarkKitchen" />
  </div>
</template>

<style>
.navbar-brand-img {
  height: 100px;
}
.sidenav .scrollbar-inner {
  overflow-y: auto;
}
</style>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "./SampleNavbar.vue";
import ContentFooter from "./SampleFooter.vue";
import DashboardContent from "../theme/Layout/Content.vue";
import { FadeTransition } from "vue2-transitions";
import SupportFab from "@/components/Tickets/SupportFab.vue";
import SupportTicketModal from "@/components/Tickets/SupportTicketModal.vue";
import MisTicketsModal from "@/components/Tickets/MisTicketsModal.vue";
import PortalUpdateModal from "@/components/PortalUpdates/PortalUpdateModal.vue";
import DailyMenuSection from "./components/DailyMenuSection.vue";
import OnDemandSection from "./components/OnDemandSection.vue";
import FranchiseSection from "./components/FranchiseSection.vue";
import OperationsManualLink from "./components/OperationsManualLink.vue";
import ManualAcknowledgementNotice from "@/components/OperationsManual/ManualAcknowledgementNotice.vue";
import kitchenChargesVisibility from "@/components/KitchenCharges/kitchenChargesVisibility";

const PORTAL_UPDATE_QUERY_KEY = "novedad";
const TICKET_QUERY_KEY = "ticket";
const TICKET_ACTION_QUERY_KEY = "action";

export default {
  mixins: [kitchenChargesVisibility],
  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent,
    FadeTransition,
    SupportFab,
    SupportTicketModal,
    MisTicketsModal,
    PortalUpdateModal,
    DailyMenuSection,
    OnDemandSection,
    FranchiseSection,
    OperationsManualLink,
    ManualAcknowledgementNotice
  },
  data() {
    return {
      showTicketModal: false,
      showMisTicketsModal: false,
      focusTicketId: "",
      ticketAction: "",
      portalUpdateQueue: [],
    };
  },
  methods: {
    onSupportClick() {
      this.showTicketModal = true;
    },
    onVerTicketsClick() {
      this.showMisTicketsModal = true;
    },
    openTicketFromLink() {
      const ticketId = this.$route.query[TICKET_QUERY_KEY];
      if (!ticketId) return;
      this.focusTicketId = String(ticketId);
      this.ticketAction = String(this.$route.query[TICKET_ACTION_QUERY_KEY] || "");
      this.showMisTicketsModal = true;
    },
    async loadPortalUpdates() {
      await this.$store.dispatch("portalUpdates/fetch");
      const requestedId = Number(this.$route.query[PORTAL_UPDATE_QUERY_KEY]);
      if (requestedId) {
        this.openPortalUpdate(requestedId);
        return;
      }
      this.portalUpdateQueue = [...this.$store.getters["portalUpdates/unread"]];
    },
    openPortalUpdate(id) {
      const item = this.$store.state.portalUpdates.items.find((candidate) => candidate.id === id);
      this.portalUpdateQueue = item ? [item] : [];
    },
    closePortalUpdates() {
      this.portalUpdateQueue = [];
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar("scrollbar-inner");

        docClasses.add("perfect-scrollbar-on");
      } else {
        docClasses.add("perfect-scrollbar-off");
      }
    },
    openCloseDropDown() {
      window.addEventListener("click", e => {
        if (window.innerWidth > this.$sidebar.breakpoint) {
          return;
        }
        if (
          e.target &&
          e.target.classList &&
          e.target.offsetParent &&
          e.target.offsetParent.classList &&
          !e.target.classList.value.includes("sidenav") &&
          !e.target.offsetParent.classList.value.includes("sidenav")
        ) {
          const element = document.querySelector(".g-sidenav-show");
          if (element) {
            element.classList.add("g-sidenav-hidden");
            element.classList.remove("g-sidenav-pinned");
          }
        }
      });
    }
  },
  mounted() {
    this.openCloseDropDown();
    document.body.classList.add('g-sidenav-pinned');
    document.body.classList.remove('g-sidenav-hidden');
    this.loadPortalUpdates();
    this.openTicketFromLink();
  },
  computed: {
    permisos() {
      return this.$store.getters.getPermissions;
    },
    hasDarkKitchen() {
      return this.$store.getters.getKitchenId !== null;
    },
    userRol() {
      return this.$store.getters.getUserRol;
    },
    isAlmacenero() {
      return this.userRol === 'ALMACENERO';
    },
  }
};
</script>
